import React from 'react'
import { FlexDiv } from '../FractionLot/style'
import Button from '../../../../components/Button'

interface FinishButtonProps {
  isSubmitting: boolean
  handleSubmit: (e?: React.FormEvent<HTMLFormElement> | undefined) => void
}

const FinishButton = ({
  isSubmitting, handleSubmit,
}: FinishButtonProps) => (
  <FlexDiv flexDirection='row' align='center' justify='flex-end' >
    <Button
      id='finishButton'
      testId='button-finish'
      style={{ marginTop: 20, marginBottom: 20 }}
      type='button'
      text='fraction.form.add'
      onClick={!isSubmitting ? handleSubmit : () => {}}
      isDisabled={isSubmitting}
      onKeyDown={(e) => e.keyCode === 32 && e.preventDefault()}
    />
  </FlexDiv>
)

export default React.memo(FinishButton)
